import { createContext, useContext, useEffect, useMemo, useState } from "react";

// View mode toggle: "user" (self-service) vs "admin" (IT/fleet).
// Persists to localStorage so a leadership walkthrough can flip in place.
// Any persona can switch — this is demo IA, not RBAC.

const STORAGE_KEY = "flexspace.viewMode";
const ViewModeContext = createContext({ view: "user", setView: () => {} });

export function ViewModeProvider({ children }) {
  const [view, setView] = useState(() => {
    if (typeof window === "undefined") return "user";
    return localStorage.getItem(STORAGE_KEY) || "user";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, view);
  }, [view]);

  const value = useMemo(() => ({ view, setView, isAdmin: view === "admin" }), [view]);
  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  return useContext(ViewModeContext);
}
